"use strict";
// invariants for the entity goes here
module.exports = entity => {
    const result = { ...entity };
    if (!entity.supplierOrganizationId) {
        const agreement = entity.copackAgreement || entity.orderBrokerageAgreement || {};
        result.supplierOrganizationId = agreement.owningSupplierOrganizationId;
    }
    return result;
};
